module.exports = __webpack_public_path__ + "static/media/home.beea4c6f.svg";